<template>
  <b-form-group
    label="Görüşme Durumu"
    label-for="title"
  >
    <validation-provider
      #default="{ errors }"
      name="Görüşme Durumu"
      rules="required"
    >
      <v-select
        v-model="interviewLine.id_interview_statuses"
        :options="statuses"
        label="title"
        :reduce="item => item.id"
        placeholder="Seçiniz"
        :disabled="isLocked"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'Country',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  props: {
    isLocked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    interviewLine() {
      return this.$store.getters['interviews/dataLine']
    },
    statuses() {
      return this.$store.getters['interviewStatuses/dataList']
    },
  },
  created() {
    this.getData()
    localize('tr')
  },
  methods: {
    getData() {
      this.$store.dispatch('interviewStatuses/getDataList', {
        select: [
          'interview_statuses.id AS id',
          'interview_statuses.title AS title',
        ],
      })
    },
  },
}
</script>
